const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

function requestProductPossessionsSuccess(summary) {
    return {
        type: actionTypes.BROKER_GET_POSSESSIONS_SUCCESS,
        payload: {
            summary
        }
    }
}

function requestProductPossessionsFailure(error) {
    return {
        type: actionTypes.BROKER_GET_POSSESSIONS_FAILURE,
        error
    }
}

function requestProductPossessionsRequest() {
    return {
        type: actionTypes.BROKER_GET_POSSESSIONS_REQUEST,
    }
}

const requestProductPossessions = (isin, iso) => (dispatch) => {
    const requestData = {
        query: {
            isin,
            iso
        }
    }
    dispatch(requestProductPossessionsRequest());

    return APIGet(dispatch, apiURLBuilder.getURL('productPossessions') , requestData)
        .then(function(data) {
            return dispatch(requestProductPossessionsSuccess(data.summary));
        }, function(response) {
            return dispatch(requestProductPossessionsFailure(response.error));
        });
}


const getProductPossessions = (isin, iso) => dispatch => {
    dispatch(requestProductPossessions(isin, iso));
}

module.exports = {
    getProductPossessions
}
